import { Pipe, PipeTransform } from '@angular/core';
import { page_fix_settings } from '@monsido/core/constants/general.constant';

@Pipe({
    name: 'pageFixSettings',
    standalone: false,
})
export class PageFixSettingsPipe implements PipeTransform {

    transform (setting: string) {
        return page_fix_settings[setting];
    }

}
